export const productListName = "PRODUCT";
export const productResourceType = "PRODUCT";
